import {match} from 'ts-pattern';
import {z} from 'zod';

import {isNil, isNotNil} from 'ramda';

import {CorrectionType} from '@dms/api/shared';
import i18n from '@dms/i18n';

export const quantitySchema = (
  minQuantity: number,
  maxQuantity: number | null,
  correctionType: CorrectionType
) =>
  match(correctionType)
    .with('VALUE_CORRECTION', () =>
      z.number().superRefine((value, ctx) => {
        // zero check
        if (value === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('entity.warehouse.validations.correctionZero'),
          });
        }
        // positive minimum check
        if (value > 0 && value < minQuantity) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('entity.warehouse.validations.correctionMinPositive', {
              min: minQuantity,
            }),
          });
        }
        // negative minimum check
        if (value < 0 && value > -minQuantity) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('entity.warehouse.validations.correctionMinNegative', {
              min: -minQuantity,
            }),
          });
        }
        // negative maximum check
        if (isNotNil(maxQuantity) && value < 0 && value < -maxQuantity) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('entity.warehouse.validations.correctionMaxNegative', {
              max: -maxQuantity,
            }),
          });
        }
      })
    )
    .otherwise(() =>
      z
        .number()
        .min(minQuantity, {
          message: i18n.t('entity.warehouse.validations.correctionMinPositive', {
            min: minQuantity,
          }),
        })
        .refine(
          (value) => {
            if (isNil(maxQuantity) || isNil(value)) {
              return true;
            }
            return value <= maxQuantity;
          },
          {
            message: i18n.t('entity.warehouse.validations.correctionMaxPositive', {
              max: maxQuantity,
            }),
          }
        )
    );
